export default __webpack_public_path__ + "static/media/liquidationIconDark.b54ed1ef.svg";